module.exports = __webpack_public_path__ + "img/about.dd229249.svg";